import React, { ReactNode } from 'react';

import HintText from '../hint-text';

import { CheckboxContainer, CheckboxLabel, FormCheckboxField } from './styles';
import { RegisterOptions, useFormContext } from 'react-hook-form';

interface CheckboxProps {
    id: string;
    name: string;
    value?: string;
    text: string | ReactNode;
    hintId?: string;
    hintText?: string | null;
    disabled?: boolean;
    checked?: boolean;
    checkboxOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined;
    registerOptions?: RegisterOptions;
    errorTitle: string;
    errors?: boolean | string;
    children?: ReactNode;
    type?: string;
    className?: string;
}

const Checkbox = ({
    id,
    name,
    value,
    text,
    hintId,
    hintText,
    disabled = false,
    checked,
    checkboxOnChange,
    registerOptions,
    errors,
    errorTitle,
    children,
    type = 'checkbox',
    className,
}: CheckboxProps) => {
    const { register } = useFormContext();
    return (
        <CheckboxContainer disabled={disabled} className={className}>
            <FormCheckboxField
                id={id}
                value={value}
                type={type}
                aria-required={!!registerOptions?.required}
                aria-describedby={hintId || undefined}
                defaultChecked={checked}
                disabled={disabled}
                aria-invalid={!!errors}
                data-errortitle={errorTitle}
                {...register(name, { ...registerOptions, onChange: checkboxOnChange })}
            />
            <CheckboxLabel $errors={!!errors} htmlFor={id}>
                {text}
            </CheckboxLabel>
            {hintText && (
                <HintText fieldsetHintText id={hintId}>
                    {hintText}
                </HintText>
            )}
            {children}
        </CheckboxContainer>
    );
};

export default Checkbox;
